// @flow
import React, { Component } from 'react';
import Vatu from '../../Elements/Vatu';
import Conditions from '../../Elements/Conditions';
import {
  useLocation,
  useNavigate,
  type Location,
  type NavigateFunction,
} from 'react-router-dom';

type Props = {
  location: Location;
  navigate: NavigateFunction;
};

type State = {
  terms: string;
  privacy: string;
  conditionsApproved: boolean;
  submitEnabled: boolean;
};

type BooleanStateKey = 'conditionsApproved' | 'submitEnabled';
type StringStateKey = 'terms' | 'privacy';

class ConsumerRegister extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      terms: '',
      privacy: '',
      conditionsApproved: false,
      submitEnabled: false,
    };
  }

  componentDidMount(): void {
    this.checkConditions();
  }

  checkConditions = (type?: BooleanStateKey): void => {
    let { terms, privacy } = this.state;

    if (!type) {
      terms = localStorage.getItem('terms') ?? '';
      privacy = localStorage.getItem('privacy') ?? '';
    }

    const key: BooleanStateKey = type || 'conditionsApproved';
    const isApproved = terms === 'approved' && privacy === 'approved';

    this.setState({ [key]: isApproved } as Pick<State, BooleanStateKey>);
  };

  toggleApprove = (e: React.ChangeEvent<HTMLInputElement>): void => {
    const item = e.target.name as StringStateKey;
    const value = this.state[item] === 'approved' ? 'declined' : 'approved';

    this.setState(
      { [item]: value } as Pick<State, StringStateKey>,
      () => this.checkConditions('submitEnabled'),
    );
  };

  onSubmit = (e: React.FormEvent<HTMLFormElement>): void => {
    localStorage.setItem('terms', this.state.terms);
    localStorage.setItem('privacy', this.state.privacy);
    e.preventDefault();
    this.checkConditions();
  };

  getToken(): string {
    const { location } = this.props;
    const parts = location.search.match('[?&]token=([^&]+)');
    return parts && parts.length >= 1 ? parts[1] : '';
  }

  render(): JSX.Element {
    const { location, navigate } = this.props;
    const { conditionsApproved, submitEnabled } = this.state;

    if (conditionsApproved) {
      navigate(-1);
    }

    if (
      /(^\?error=cancel)/.test(location.search) ||
      /(^\?error=reject)/.test(location.search)
    ) {
      return (
        <div className="wrapper">
          <h1>Tunnistautuminen keskeytyi</h1>
          <h5>Jatka halutessasi takaisin tunnistautumiseen.</h5>
          <Vatu label={''} />
        </div>
      );
    }

    return (
      <div className="wrapper">
        <h1>Palvelun käyttöehdot ja tietosuojaseloste</h1>
        <Conditions
          onChange={this.toggleApprove}
          onSubmit={this.onSubmit}
          submitEnabled={submitEnabled}
        />
      </div>
    );
  }
}

export function ConsumerRegisterRouteWrapper(): JSX.Element {
  const location = useLocation();
  const navigate = useNavigate();

  return <ConsumerRegister location={location} navigate={navigate} />;
}

export default ConsumerRegister;
